import { Outlet } from "react-router-dom";

import { ErrorBoundary } from "@dzambalaorg/mui-page-layout";
import { AppShellLayout } from "@dzambalaorg/ui-kit";
import { GlobalFormDialog, GlobalViewDialog } from "@framework/shared";

import { Header } from "../header";
import { adminGlobalDialogComponentsSchema } from "../../../shared";

export const Layout = () => {
  return (
    <AppShellLayout header={<Header />}>
      <AppShellLayout.Main>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </AppShellLayout.Main>
      <GlobalFormDialog externalDialogComponentSchema={adminGlobalDialogComponentsSchema} />
      <GlobalViewDialog externalDialogComponentSchema={adminGlobalDialogComponentsSchema} />
    </AppShellLayout>
  );
};
